import { get } from "lodash";

const styles = ({ color, fontSize, fontWeight }) => ({
  listContainer: {
    paddingTop: '0 !important',
  },
  pageFilterAndSort: {
    justifyContent: 'start',
    marginTop: '0px',
  },
  textFiltersContainer: {
    display: 'contents',
  },
  filterField: {
    maxWidth: '12%',
    width: 100,
    marginRight: 5,
  },
  actionButton: {
    color: get(color, 'primaryButtonBackground'),
    fontSize: get(fontSize, 'bodyText'),
    fontWeight: get(fontWeight, 'normal'),
    height: 20,
    padding : 0,
    justifyContent : 'flex-start',
  },
  restoreDefaultButton: {
    textTransform: 'none',
    color: 'red',
    borderColor: 'red',
    borderRadius: 3,
    marginRight : 100,
  },
  alertMessages: {
    minWidth: 'fit-content',
    width : 'max-content',
    left: '35% !important',
    backgroundColor: get(color, 'white'),
    color: get(color, 'black'),
    fontWeight: 800,
    '& .MuiSnackbarContent-message': {
      width: 'fit-content',
    },
  },
  alertMessagesCloseButton : {
    color : "#114599",
  },
  helpIcon: {
    color: color.primaryButtonBackground,
    marginLeft: 6,
    marginTop: 3,
    height: 24,
    width: 24,
  },
  helpIconContainer: {
    alignItems: 'center',
    display: 'flex',
  },
});

export default styles;
